import React, { createContext, useContext } from 'react';
import mixpanel from 'mixpanel-browser';
import ProjectConfig from 'ProjectConfig';

const config = {
  batch_requests: ProjectConfig.MIXPANEL?.batch_requests,
  debug: ProjectConfig.DEBUG,
  persistence: 'localStorage',
  flags: true
};

mixpanel.init(ProjectConfig.MIXPANEL?.token, config);

export const toggleMixpanelTracking = consent => {
  if (consent) {
    mixpanel.opt_in_tracking(config);
  } else {
    mixpanel.clear_opt_in_out_tracking();
    mixpanel.opt_out_tracking();
  }
};

export const context = createContext(null);

export const Consumer = context.Consumer;
export const Provider = context.Provider;

export const useMixpanel = () => useContext(context);

// eslint-disable-next-line react/display-name
export const withMixpanel = Component => props => (
  <Consumer>
    { mixpanel => (
      <Component mixpanel={ mixpanel } { ...props } />
    ) }
  </Consumer>
);

export const getVariantValue = async (flagName, defaultValue = '1') => {
  try {
    if (mixpanel?.flags && typeof mixpanel.flags.get_variant_value === 'function') {
      const variant = await mixpanel.flags.get_variant_value(flagName, defaultValue);
      return variant;
    }
    return defaultValue;
  } catch (e) {
    return defaultValue;
  }
};

export default mixpanel;
